export default function Game_Rotation() {
  return (
    <div>
      <h1>Game_Rotation Component</h1>
    </div>
  );
}
